module.exports = "<svg viewBox=\"0 0 123.2 123.2\"><path d=\"M56.5 0h10v123.2h-10z\" class=\"st0\"></path><path d=\"M0 56.5h123.2v10H0z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/cross.svg
// module id = 279
// module chunks = 1